import React from "react";
import TextTaskInput from "./TextTaskInput";
import FileTaskInput from "./FileTaskInput";

export default function TaskRenderer({ tasks, values, onChange, errors }) {
  if (!tasks || tasks.length === 0) {
    return (
      <div className="no-tasks">
        No tasks for this stage. Select a transition to proceed.
      </div>
    );
  }

  return (
    <div className="task-list">
      {tasks.map((task) => {
        const val = values[task.id];
        const err = errors && errors[task.id];
        if (task.type === "file") {
          return (
            <FileTaskInput
              key={task.id}
              task={task}
              value={val}
              onChange={(v) => onChange(task.id, v)}
              error={err}
            />
          );
        }
        return (
          <TextTaskInput
            key={task.id}
            task={task}
            value={val}
            onChange={(v) => onChange(task.id, v)}
            error={err}
          />
        );
      })}
    </div>
  );
}
